import { useMemo } from 'react';
import { useSelector } from '../../shared/hooks';

const DISPLAY_TYPES = [{ value: 'total', label: 'Totals' }];

export function useDisplayFilter(lineupId, analysis) {
  const lineupOptions = useMemoizedLineups(analysis);
  const lineups = useSelector(lineupOptions, lineupId, { empty: true });
  const displayTypes = useSelector(DISPLAY_TYPES, DISPLAY_TYPES[0].value);
  const lineup = useLineup(lineups.value, analysis);

  return { lineups, lineup, displayTypes };
}

function useLineup(id, analysis) {
  const lineupId = +id;
  return useMemo(() => {
    const lineups = (analysis && analysis.lineups) || [];
    return lineups.find(l => l.lineup.id === lineupId);
  }, [lineupId, analysis]);
}

function useMemoizedLineups(analysis) {
  return useMemo(() => {
    const lineups = (analysis && analysis.lineups) || [];
    return getLineupOptions(lineups);
  }, [analysis]);
}

function getLineupOptions(lineups) {
  const lineupsOptions = lineups
    ? lineups.map(data => {
        const value = data.lineup.id;
        var label = data.lineup.players
          .map(player => `${player.jersey} ${player.name}`)
          .join(' / ');
        label = `${label} (${data.boxscore.minutes} min)`;
        return { value, label };
      })
    : [];
  lineupsOptions.sort((a, b) => a.label.localeCompare(b.label));
  return lineupsOptions;
}
